import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SafePipe } from '../../pipes/safe.pipe';

@Component({
  selector: 'app-cms-approval-code',
  templateUrl: './cms-approval-code.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, SafePipe]
})
export class CmsApprovalCodeComponent {
  @Input() CMS: string = '';
  @Input() formCMS: string = '';
  @Input() lastUpdatedLabel: string = '';
  @Input() showMainCMS: boolean = true;
  @Input() showLastUpdated: boolean = true;

  readonly defaultCMS: string = 'CMS Pending Approval';
}
